import axios from "../../../api/axios";
import axiosPrivate from "../../../api/axiosPrivate";
import { GET_TENANT_DETAILS, LOGIN_URL, LOGOUT, RESET_PASSWORD } from "../../../api/constant";
import { removeSessionToken } from "../../../utils/helpers/storage";

// Authenticate user
const login = async (userData) => {
    
    // const response = await axiosPrivate.post(LOGIN_URL, userData)
    const response = await axios.post(LOGIN_URL, userData)    
    return response.data
}

const resetPassword = async (data) => {   
    // const response = await axiosPrivate.post(LOGIN_URL, userData)
    const response = await axios.post(RESET_PASSWORD, data)    
    return response.data
}

// Log out user
const logout = async () => {
    const response = await axiosPrivate.get(LOGOUT)
    removeSessionToken('accessToken')   
}

const getDetails = async () => {
    const response = await axiosPrivate.get(GET_TENANT_DETAILS)
    return response.data
}

const authService = {
    login,
    logout,
    getDetails,
    resetPassword
}

export default authService